import '../App.css';
import img_tablet from '../tablet.png';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import { RadioButton } from 'primereact/radiobutton';

import { getDevices } from '../QueryDevice';
import { loadCampaign, patchCampaign } from '../QueryCampaign';
import V2Card from '../V2Card';

function CampaignAudience({ campaign_id }) {
    const navigate = useNavigate();

    const [campaign, setCampaign] = useState();
    const [selectedOption, setSelectedOption] = useState('');
    const [devices, setDevices] = useState([]);

    useEffect(
        () => {
            loadCampaign(campaign_id).then(
                (response) => {
                    setCampaign(response.data);
                    setSelectedOption(response.data.audience_type);
                }
            ).catch(
                (error) => {
                    navigate('/');
                }
            )

            getDevices().then(
                (response) => setDevices(response.data)
            ).catch(
                (error) => {
                    navigate('/');
                }
            );
        },
        [],
    )

    if (!campaign) {
        return <ProgressSpinner />;
    }

    const options = [
        {
            value: 'all_devices',
            title: 'My Devices + Devices from External Publishers',
        },
        {
            value: 'my_devices',
            title: 'My Devices Only',
        },
    ]
    const divDevices = devices.map(
        d =>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginRight: '1em',
                    marginBottom: '1em',
                }}>
                <img src={img_tablet} width={100} />
                <div style={{ marginLeft: '0.5em' }}>
                    {d.title}
                </div>
            </div>
    )

    const divOptions = options.map(
        option =>
            <div
                style={{
                    cursor: 'pointer',
                    marginTop: '1em',
                }}
                onClick={
                    () => {
                        setSelectedOption(option.value);
                    }
                }
            >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <RadioButton
                        inputId="ingredient1"
                        name="pizza"
                        value="Cheese"
                        onChange={
                            (e) => {

                            }
                        }
                        checked={option.value == selectedOption}
                        size='small'
                    />
                    <div style={{ marginLeft: '0.5em' }}>
                        {option.title}
                    </div>
                </div>
                {
                    option.value == 'specific_devices' &&
                    selectedOption == 'specific_devices' &&
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        {divDevices}
                    </div>
                }
            </div>
    )

    return (
        <V2Card>
            {divOptions}
            <Button
                label='Save'
                severity='success'
                onClick={
                    () => {
                        patchCampaign(
                            campaign.id,
                            {
                                audience_type: selectedOption,
                            }
                        ).then(
                            (response) => navigate('/campaigns/')
                        ).catch(
                            (error) => navigate('/')
                        )
                    }
                }
                disabled={selectedOption == campaign.audience_type}
                size='small'
                style={{ marginTop: '1em' }}
                outlined
            />
        </V2Card>
    );
}

export default CampaignAudience;
